import type {
  AdapterWallet,
  AptosSignAndSubmitTransactionOutput,
  InputTransactionData,
} from "@aptos-labs/wallet-adapter-core";

export interface TransactionOptions {
  wallet: {
    wallet: AdapterWallet | null;
    signAndSubmitTransaction: (input: InputTransactionData) => Promise<AptosSignAndSubmitTransactionOutput>;
  };
  data: InputTransactionData["data"];
  sender?: string;
}

export const submitTransaction = async (options: TransactionOptions) => {
  const { wallet, data, sender } = options;

  const transactionInput: InputTransactionData = {
    data,
    sender,
  };

  return await wallet.signAndSubmitTransaction(transactionInput);
};
